import {IForecastWeather} from '@deep-planet/api-interfaces';
import React from 'react';
import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';
import {handleDateFormat} from '../../../../../helpers/dateHelpers';
import {useMeasurementConversion} from '../../../../../hooks/useMeasurementConversion';
import {useTranslation} from 'react-i18next';
import Avatar from '@material-ui/core/Avatar';
import theme from 'apps/web-portal-ui/src/app/utilities/theme';

const Container = styled.div`
  width: 100%;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 16px;
  padding: 0 5%;
  width: 100%;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-inline: 20px;
  min-width: 92px;
  gap: 0px;
`;

const DateText = styled(Typography)`
  && {
    color: ${theme.palette.primary.main};
    font-weight: 600;
  }
`;

const IconText = styled(Typography)`
  && {
    opacity: 0.7;
    text-align: center;
  }
`;

const TemperatureText = styled(Typography)`
  min-width: 110px;
  text-align: center;
  margin: 0;
`;

const Separator = styled.span`
  margin: 0 5px;
`;

interface Props {
  forecastWeather: IForecastWeather[];
}

const WeatherForecast = ({forecastWeather}: Props) => {
  const {t} = useTranslation();
  const {temperatureUnit, convertTemperature, round} = useMeasurementConversion();

  return (
    <Container>
      <Row>
        {forecastWeather?.map((weather, idx) => (
          <Column key={idx}>
            <DateText variant="body1">{handleDateFormat(weather.epochTime * 1000)}</DateText>
            <Avatar src={weather.day.icon} alt="Weather Icon" style={{width: 42, height: 42}} />
            <IconText variant="body2">{weather.day.iconText}</IconText>
            <TemperatureText variant="body1" color="primary">
              <strong>
                {round(convertTemperature(weather.temperature.minimum.value), 0)}°{temperatureUnit[0].toUpperCase()}
                <Separator>|</Separator>
                {round(convertTemperature(weather.temperature.maximum.value), 0)}°{temperatureUnit[0].toUpperCase()}
              </strong>
            </TemperatureText>
          </Column>
        ))}
      </Row>
    </Container>
  );
};

export default WeatherForecast;
